// Analytics properties for whether a plan is shown with a discount, so upgrade
// funnels can be compared for discounted and full-price plans.
export const discountTrackingProperties = plan => {
  const isDiscounted = Boolean(plan?.promo_code?.valid)

  return {
    is_discounted: isDiscounted,
    promo_code: isDiscounted ? plan.promo_code.redemption_code : null
  }
}
